// Search parameter keys for expenses page
export const EXPENSES_PAGE_SEARCH_KEYS = Object.freeze({
  SELECTED_EXPENSE_ID: 'selectedExpenseId',
});
